import React, { useState } from 'react';
import axios from 'axios';
import { FaWhatsapp, FaSpinner } from 'react-icons/fa';

const DailyMessage = () => {
    const [message, setMessage] = useState('');
    const [date, setDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const generateMessage = async () => {
        setLoading(true);
        setError('');
        try {
            const response = await axios.get('https://klimkaara-backend-pgnq.onrender.com/gemini/motivation');
            if (response.data.success) {
                setMessage(response.data.message);
                setDate(response.data.date);
            }
        } catch (error) {
            setError('Failed to generate message. Please try again.');
            console.error('Error:', error);
        }
        setLoading(false);
    };

    const shareOnWhatsApp = () => {
        if (message) {
            const whatsappText = encodeURIComponent(`*Daily Motivation - ${date}*\n\n${message}`);
            window.open(`https://wa.me/?text=${whatsappText}`, '_blank');
        }
    };

    return (
        <div className="min-h-screen bg-gray-900 text-white py-16">
            <div className="container mx-auto px-4">
                <h2 className="text-4xl font-bold text-center mb-10">Daily Motivational Message</h2>
                
                <div className="max-w-2xl mx-auto bg-gray-800 p-8 rounded-lg shadow-lg">
                    <div className="flex justify-center mb-8">
                        <button
                            onClick={generateMessage}
                            disabled={loading}
                            className="bg-[#fded22] text-black px-6 py-3 rounded-full font-semibold hover:bg-white transition flex items-center gap-2"
                        >
                            {loading ? (
                                <>
                                    <FaSpinner className="animate-spin" />
                                    Generating...
                                </>
                            ) : (
                                'Generate Message'
                            )}
                        </button>
                    </div>

                    {error && (
                        <div className="text-red-500 text-center mb-4">
                            {error}
                        </div>
                    )}

                    {message && (
                        <div className="text-center">
                            <div className="mb-4">
                                <h3 className="text-xl font-semibold mb-2">{date}</h3>
                                <p className="text-lg">{message}</p>
                            </div>
                            
                            <button
                                onClick={shareOnWhatsApp}
                                className="bg-[#25D366] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#128C7E] transition flex items-center gap-2 mx-auto"
                            >
                                <FaWhatsapp className="text-xl" />
                                Share on WhatsApp
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DailyMessage; 